import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/ko'

// components
import SubmitModal from '../../components/modal/SubmitModal'
import { HeaderTab, ScrollButton } from '../../components'
import OrderDetail from '../../components/orderDetail/OrderDetail'
import MoOrderDetail from '../../components/moOrderDetail/MoOrderDetail'
import OrderDateBox from '../../components/orderDetail/OrderDateBox'

// globals
import * as TYPE from '../../globals/type'

// styles
import theme from '../../styles/theme'

// [ 기간별 주문현황: startDate, endDate 있음 ]
const SelectOrderList = () => {
  const navigate = useNavigate()
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800)
  // 디폴트 오늘 -> 30일
  const [send, setSend] = useState({
    startDate: moment().subtract(30, 'd').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  })
  // const [send, setSend] = useState()
  const [data, setData] = useState()

  // console.log('send', send)
  // console.log('setSend', setSend)

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 800)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleTab = (flag) => {
    switch (flag) {
      case 0:
        return navigate(`/${TYPE.TAB_URL.TODAY_ORDER_LIST}`, {
          replace: false,
        })

      case 1:
        return

      default:
        break
    }
  }

  return (
    <>
      {/* <ScrollButton /> */}
      <OrderListWrap>
        <HeaderTab
          headerItem={['당일 주문현황', '기간별 주문현황']}
          selectedItem={1}
          handleItem={handleTab}
          maxWidth={984}
        />
        <div className="mobileBox">
          <OrderDateBox setSend={setSend} data={data} />
        </div>
        <ReponsiveWrap>
          {isMobile ? (
            <div className="mobile-content">
              <MoOrderDetail
                send={send}
                orderMode={'DURATION'}
                setData={setData}
              />
            </div>
          ) : (
            <div className="desktop-content">
              <OrderDetail
                send={send}
                orderMode={'DURATION'}
                setData={setData}
              />
            </div>
          )}
        </ReponsiveWrap>
      </OrderListWrap>
    </>
  )
}

export default SelectOrderList

const OrderListWrap = styled.section`
  width: 100%;
  max-width: 984px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;

  .boxShadow {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    padding: 40px 30px;

    @media ${(props) => props.theme.tablet} {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }

  .mobileBox {
    margin-bottom: 42px;
    @media ${(props) => props.theme.tablet} {
      padding: 20px 20px 30px;
    }
  }
`
const ReponsiveWrap = styled.div`
  .mobile-content {
    @media ${(props) => props.theme.desktop} {
      display: none;
    }
    @media (max-width: 800px) {
      display: block;
    }
  }
  .desktop-content {
    @media ${(props) => props.theme.desktop} {
      display: block;
    }
    @media (max-width: 800px) {
      display: none;
    }
  }
`
